module.exports = __webpack_public_path__ + "static/img/rank2.2c9d6d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank/rank2.png
// module id = UXf+
// module chunks = 0